<mat-chip-option
  class="chip"
  color="primary"
  matTooltip="{{ 'NGX-MESSAGING.FILTER.' + (check?.tooltip || check?.name) | translate }}"
  (click)="setValue()"
  [selected]="!!check.value"
  [ngClass]="{ 'chip--active': !!check.value }">
  <ng-container *hasWorkspaceFeature="[WorkspaceFeatures.showUnreadsCounter]">
    @if (check.field === 'readStatus' && unreads()) {
    <span>({{ unreads() }})</span>
    }
  </ng-container>

  {{ 'NGX-MESSAGING.FILTER.' + check.name | translate }}
</mat-chip-option>
